import { axiosHttpClient } from "../axios";
import handleStatusCases from "../handle-status-cases";

const { REACT_APP_BASE_URL } = process.env;

export type TCreateBudgetDocumentById = {
    budgetId: string;
    params: {
        document_title: string;
        enterprise: string;
        project: string;
    };
};

export type TCreateDocumentByIdResponse = {
    data: any;
};

export default async ({ budgetId, params }: TCreateBudgetDocumentById) => {
    const httpResponse = await axiosHttpClient({
        url: `${REACT_APP_BASE_URL}/budget/documents/${budgetId}`,
        method: "post",
        headers: { auth: true },
        body: params,
    });
    const { body, statusCode } = httpResponse;

    return handleStatusCases<TCreateDocumentByIdResponse>({
        body,
        statusCode,
    });
};
